jQuery(document).ready(function(){
    jQuery('.hotspot-wrapper').click(function(event){
        jQuery('.active-tab').removeClass('active-tab');
        jQuery(this).addClass('active-tab');
        event.preventDefault();
    });
});
$(document).ready(function () {
    $('.hotspot').on('click', function () {
        $('.hotspot').not(this).removeClass('active');
        $('.hotspot-content-wrapper').not('.hotspot-content-wrapper', this).removeClass('active');
        $(this).toggleClass('active');
        var index = $('.hotspot').index(this);
        $('.hotspot-content-wrapper').eq(index).toggleClass('active');
    });
});
